//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
//供应商发货指令
const supplierDeliveryOrder = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/stockManage/index.vue')),
    'supplierDeliveryOrder'
  );
//创建供应商发货指令
const addSupplierDelivery = () =>
  import('@/pages/wareHouse/stockManage/supplierDeliveryOrderModel/addSupplierDelivery.vue');
//供应商发货指令详情
const supplierDeliveryDetail = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/pages/wareHouse/stockManage/supplierDeliveryOrderModel/supplierDeliveryDetail.vue')
      ),
    'supplierDeliveryDetail'
  );
//库存调拨单列表
const inventoryTransferList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/inventoryTransfer/list.vue')),
    'inventoryTransferList'
  );
//库存调拨单新增
// const inventoryTransferAdd = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/wareHouse/inventoryTransfer/add.vue')),
//     'inventoryTransferAdd'
//   );
//库存调拨单修改
const inventoryTransferEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/inventoryTransfer/add.vue')),
    'inventoryTransferEdit'
  );
//库存调拨单详情
const inventoryTransferDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/inventoryTransfer/detail.vue')),
    'inventoryTransferDetail'
  );
//报损报溢单
const lossOverflowReportList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/lossOverflowReport/list.vue')),
    'lossOverflowReportList'
  );
//报损报溢单新增
// const lossOverflowReportAdd = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/wareHouse/lossOverflowReport/add.vue')),
//     'lossOverflowReportAdd'
//   );
//报损报溢单修改
const lossOverflowReportEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/lossOverflowReport/edit.vue')),
    'lossOverflowReportEdit'
  );
//报损报溢单详情
const lossOverflowReportDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/lossOverflowReport/detail.vue')),
    'lossOverflowReportDetail'
  );
// 库存详情
// const inventoryQueryList = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/wareHouse/inventoryQuery/list.vue')),
//     'inventoryQueryList'
//   );
// 成本调整单详情
const costAdjustOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/costAdjustOrder/list.vue')),
    'costAdjustOrderList'
  );
// 成本调整单新增
const costAdjustOrderAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/costAdjustOrder/add.vue')),
    'costAdjustOrderAdd'
  );
//成本调整单修改
const costAdjustOrderEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/costAdjustOrder/edit.vue')),
    'costAdjustOrderEdit'
  );
//物流报损报溢单
const logisticsLOReportList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/logisticsLossOverflowReport/list.vue')),
    'logisticsLOReportList'
  );
//物流报损报溢单新增
const logisticsLOReportAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/logisticsLossOverflowReport/add.vue')),
    'logisticsLOReportAdd'
  );
//物流报损报溢单修改
const logisticsLOReportEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/logisticsLossOverflowReport/edit.vue')),
    'logisticsLOReportEdit'
  );
//物流报损报溢单详情
const logisticsLOReportDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/wareHouse/logisticsLossOverflowReport/detail.vue')),
    'logisticsLOReportDetail'
  );
//委托加工列表
const mcInboundList = () =>
  import(/* webpackChunkName:'mcInboundLst' */ '@/pages/wareHouse/mcInbound/mcInboundList.vue');
//委托加工新增
const mcInboundAdd = () =>
  import(/* webpackChunkName:'mcInboundLst' */ '@/pages/wareHouse/mcInbound/mcInboundAdd.vue');
//委托加工详情
const mcInboundEdit = () =>
  import(/* webpackChunkName:'mcInboundLst' */ '@/pages/wareHouse/mcInbound/mcInboundEdit.vue');
// 物贸供应商指令发货
const materiaSupplierDeliveryOrder = () =>
  import('@/pages/wareHouse/stockManage/materialTrade/supplierDeliveryOrder.vue');
// 新增物贸供应商指令发货
// const addMateriaSupplierDeliveryOrder = () =>
//   import('@/pages/wareHouse/stockManage/materialTrade/addMateriaSupplierDeliveryOrder.vue');
const wareHouseRouter = {
  path: '/wareHouse',
  component: index,
  children: [
    // 物贸供应商发货指令
    {
      path: 'materiaSupplierDeliveryOrder',
      name: 'materiaSupplierDeliveryOrder',
      component: materiaSupplierDeliveryOrder,
      meta: {
        keepAlive: true,
        title: '供应商发货指令',
      },
    },
    {
      path: 'addMateriaSupplierDeliveryOrder',
      name: 'addMateriaSupplierDeliveryOrder',
      component: () =>
        import('@/pages/wareHouse/stockManage/materialTrade/addMateriaSupplierDeliveryOrder.vue'),
      meta: {
        keepAlive: true,
        title: '供应商发货指令维护',
      },
    },
    {
      path: 'supplierDeliveryOrder',
      name: 'supplierDeliveryOrder',
      component: supplierDeliveryOrder,
      meta: {
        keepAlive: true,
        title: '供应商发货指令',
      },
    },
    {
      path: 'addSupplierDelivery',
      name: 'addSupplierDelivery',
      component: addSupplierDelivery,
      meta: {
        keepAlive: true,
        title: '供应商发货指令维护',
      },
    },
    {
      path: 'supplierDeliveryDetail',
      name: 'supplierDeliveryDetail',
      component: supplierDeliveryDetail,
      meta: {
        keepAlive: true,
        title: '供应商发货指令详情',
      },
    },
    {
      path: 'inventoryTransferList',
      name: 'inventoryTransferList',
      component: inventoryTransferList,
      meta: {
        keepAlive: true,
        title: '库存调拨单列表',
      },
    },
    {
      path: 'inventoryTransferAdd',
      name: 'inventoryTransferAdd',
      component: () => import('@/pages/wareHouse/inventoryTransfer/add.vue'),
      meta: {
        keepAlive: true,
        title: '库存调拨单新增',
      },
    },
    {
      path: 'inventoryTransferEdit',
      name: 'inventoryTransferEdit',
      component: inventoryTransferEdit,
      meta: {
        keepAlive: true,
        title: '库存调拨单修改',
      },
    },
    {
      path: 'inventoryTransferDetail',
      name: 'inventoryTransferDetail',
      component: inventoryTransferDetail,
      meta: {
        keepAlive: true,
        title: '库存调拨单详情',
      },
    },
    {
      path: 'lossOverflowReportList',
      name: 'lossOverflowReportList',
      component: lossOverflowReportList,
      meta: {
        keepAlive: true,
        title: '报损报溢单列表',
      },
    },
    {
      path: 'lossOverflowReportAdd',
      name: 'lossOverflowReportAdd',
      component: () => import('@/pages/wareHouse/lossOverflowReport/add.vue'),
      meta: {
        keepAlive: true,
        title: '报损报溢单新增',
      },
    },
    {
      path: 'lossOverflowReportEdit',
      name: 'lossOverflowReportEdit',
      component: lossOverflowReportEdit,
      meta: {
        keepAlive: true,
        title: '报损报溢单修改',
      },
    },
    {
      path: 'lossOverflowReportDetail',
      name: 'lossOverflowReportDetail',
      component: lossOverflowReportDetail,
      meta: {
        keepAlive: true,
        title: '报损报溢单详情',
      },
    },
    {
      path: 'inventoryQueryList',
      name: 'inventoryQueryList',
      component: () => import('@/pages/wareHouse/inventoryQuery/list.vue'),
      meta: {
        keepAlive: true,
        title: '库存实时查询',
      },
    },
    {
      path: 'costAdjustOrderList',
      name: 'costAdjustOrderList',
      component: costAdjustOrderList,
      meta: {
        keepAlive: true,
        title: '成本调整单查询',
      },
    },
    {
      path: 'costAdjustOrderAdd',
      name: 'costAdjustOrderAdd',
      component: costAdjustOrderAdd,
      meta: {
        keepAlive: true,
        title: '成本调整单新增',
      },
    },
    {
      path: 'costAdjustOrderEdit',
      name: 'costAdjustOrderEdit',
      component: costAdjustOrderEdit,
      meta: {
        keepAlive: true,
        title: '成本调整单编辑',
      },
    },
    {
      path: 'logisticsLOReportList',
      name: 'logisticsLOReportList',
      component: logisticsLOReportList,
      meta: {
        keepAlive: true,
        title: '物流报损报溢单列表',
      },
    },
    {
      path: 'logisticsLOReportAdd',
      name: 'logisticsLOReportAdd',
      component: logisticsLOReportAdd,
      meta: {
        keepAlive: true,
        title: '物流报损报溢单新增',
      },
    },
    {
      path: 'logisticsLOReportEdit',
      name: 'logisticsLOReportEdit',
      component: logisticsLOReportEdit,
      meta: {
        keepAlive: true,
        title: '物流报损报溢单修改',
      },
    },
    {
      path: 'logisticsLOReportDetail',
      name: 'logisticsLOReportDetail',
      component: logisticsLOReportDetail,
      meta: {
        keepAlive: true,
        title: '物流报损报溢单详情',
      },
    },
    {
      path: 'mcInboundList',
      name: 'mcInboundList',
      component: mcInboundList,
      meta: {
        keepAlive: true,
        title: '委托加工入库单列表',
      },
    },
    {
      path: 'mcInboundAdd',
      name: 'mcInboundAdd',
      component: mcInboundAdd,
      meta: {
        keepAlive: true,
        title: '新增委托加工入库单',
      },
    },
    {
      path: 'mcInboundEdit',
      name: 'mcInboundEdit',
      component: mcInboundEdit,
      meta: {
        keepAlive: true,
        title: '委托加工入库单详情',
      },
    },
  ],
};
export default wareHouseRouter;
